export default __webpack_public_path__ + "static/media/hn.66a51f16.jpg";